import api from "./api";
import { logAnalyticsEvent } from "./firebase.js";

export const getUsers = async (query) => {
    const userList = (
        await api.get(`/users`, {
            params: query,
        })
    ).data;
    return userList;
};

export const updateUser = async ({ userId, data }) => {
    return await api.put("/users/" + userId, data);
};

export const removeUser = async (userId) => {
    return await api.delete("/users/" + userId);
};

export const closeSession = () => {

    localStorage.removeItem("tagCache")
    localStorage.removeItem("articleCache")
    localStorage.removeItem("pageCache")
    localStorage.removeItem("endDate")
    localStorage.removeItem("startDate")
    localStorage.removeItem("ordersCache")
    localStorage.removeItem("user");
    localStorage.removeItem("global-color");
    window.location = "/"
    setTimeout(() => {
        window.location.reload();
    }, 500);
};

export const signUp = async ({
    name,
    email,
    phone,
    password,
    active = true
}) => {

    const authResponse = await api.post("/users", {
        name,
        email,
        phone,
        password,
        active
    })
    logAnalyticsEvent("sign_up")
    return authResponse.data
}

export const getUserToken = async (email) => {
    const authToken = await api.get("/users/get-user-token/" + email)

    return authToken.data
}
